import { Fragment } from "react";
import { Grid, Container } from "@material-ui/core";
import BlockIcon from "@material-ui/icons/Block";

import { Margin } from "../styles/GerenciamentoContrato";

import TableDefault from "../../../../components/grid/TableDefault";
import MaskService from "../../../../utils/mask/maskService";
import useGerenciamentoContratoListagemController from "../controllers/GerenciamentoContratoListagemController";

const TabDespesas = ({ content, setContent, setCrRows }) => {
  const { removeDespesa } = useGerenciamentoContratoListagemController();

  const cancelaDispesa = async (id) => {
    let copy = content;

    let cancelamentoDespesa = await removeDespesa(
      copy,
      id,
      content[0].pivot.id_cr,
      setCrRows
    );

    if (cancelamentoDespesa) {
      let index = copy.findIndex((e) => e.id === id);
      copy[index] = {
        ...copy[index],
        rowError: true,
      };
      setContent((e) => ({ ...e, despesas: copy }));
    }

    return;
  };

  const columns = [
    {
      id: "id",
      label: "ID",
      align: "left",
    },
    {
      id: "descricao",
      label: "Descrição",
      align: "left",
    },
    {
      id: "complemento",
      label: "Complemento",
      align: "left",
    },
    {
      id: "valor",
      label: "Valor",
      align: "left",
      format: (value) =>
        `R$ ${
          value?.pivot?.valor
            ? MaskService.toMask("decimal", value?.pivot?.valor)
            : "0,00"
        } `,
    },
    {
      label: "Cancela Despesa",
      name: "cancelar",
      format: (value) =>
        value.pivot.cancelado === 0 &&
        !value.rowError && (
          <BlockIcon
            style={{ cursor: "pointer" }}
            color="error"
            onClick={() => cancelaDispesa(value.id)}
          />
        ),
    },
  ];

  return (
    <>
      <Margin top={25}>
        <Container maxWidth="lg">
          <Margin top={25}>
            <Grid item xs={12}>
              <TableDefault
                columns={columns}
                values={content.map((row) => {
                  return {
                    ...row,
                    rowError: row.rowError || row.pivot.cancelado === 1,
                  };
                })}
                minHeight="350px"
                orderSort="desc"
                selectedByRow={true}
                rowsPerPage={content?.length}
                disabledDefaultPagination
                disabledEmptySpace
              />
            </Grid>
          </Margin>
        </Container>
      </Margin>
    </>
  );
};

export default TabDespesas;
